export const Config = {
  /** Gets the specified window.ui variable */
  get(key: string): unknown {
    if (window.ui && Object.getOwnPropertyDescriptor(window.ui, key)) {
      return (window.ui as Record<string, unknown>)[key];
    } else {
      return undefined;
    }
  },

  get staticBasePath(): unknown {
    return this.get('staticBasePath');
  },

  /** Sets a global config value */
  set(key: string, value: unknown) {
    const newObj: Record<string, unknown> = {};
    newObj[key] = value;
    Object.assign(window.ui, newObj);
  }
};
